import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background: ${(props) => props.theme.color.ui.shade1};
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background: ${(props) => props.theme.color.bg.primary};
  }
`;

export const LogoImg = styled.img`
  width: 120px;
  height: auto;
`;

export const Title = styled.h3`
  color: ${(props) => props.theme.color.text.primary};
`;

export const LoginContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 760px;
  height: 600px;

  background-color: cadetblue;
  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }
`;

export const LeftContainer = styled.div`
  width: 380px;
  background: white;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    padding: 0 10px;

    form {
      max-width: 380px;
    }
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 100%;
  background: #f2f2f2;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

export const TextContainer = styled.div`
  padding: 0 32px;

  h2 {
    font-family: ${(props) => props.theme.font.body.family};
  }
`;

export const LoginFooter = styled.div`
  width: 100%;
  margin-top: 25px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    color: ${(props) => props.theme.color.text.disabled};
  }
`;

export const Link = styled(RouterLink)`
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  color: ${(props) => props.theme.color.text.secondary};
`;

export const ForgotPasswordContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SmallLink = styled(Link)`
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  color: ${(props) => props.theme.color.text.disabled};
`;

export const AnalystsImg = styled.img`
  width: 400px;
  height: auto;
`;

export const Button = styled.button`
  height: 38px;
  margin-top: 10px;
  background-color: ${(props) => props.theme.color.ui.primary};
  color: ${(props) => props.theme.color.text.inverse};
  border-radius: 3px;
  border: none;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    opacity: 0.95;
  }
`;

export const SocialSignInContainer = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    max-width: 380px;
  }
`;

export const SocialOrContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  color: ${(props) => props.theme.color.text.disabled};
`;

export const SocialLogoImg = styled.img`
  width: 24px;
  height: auto;
`;

// Botão de verdade (out/2026): era div clicável — fora do teclado e do leitor
// de tela.
const SocialButton = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  height: 38px;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  color: ${(props) => props.theme.color.text.primary};
  padding: 0 8px;
  cursor: pointer;

  div {
    &:nth-child(1) {
      display: flex;
      align-items: center;
    }
    &:nth-child(2) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const GoogleButton = styled(SocialButton)`
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => props.theme.color.ui.shade2};
`;

export const FacebookButton = styled(SocialButton)`
  margin-top: 20px;
  background-color: #4267b2;
  color: ${(props) => props.theme.color.text.inverse};
`;
